import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  static targets = ["processingTemplate", "successTemplate", "errorTemplate"]

  start(event) {
    event.preventDefault()
    this.showProcessingModal()
    this.initiateDownload()
  }

  initiateDownload() {
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      }
    })
      .then(response => response.json())
      .then(data => this.subscribeToDownload(data.download_id))
      .catch(error => this.showError(error))
  }

  subscribeToDownload(downloadId) {
    this.subscription = window.Cable.subscriptions.create(
      { channel: "DownloadsChannel", download_id: downloadId },
      {
        received: (data) => this.handleDownloadUpdate(data)
      }
    )
  }

  handleDownloadUpdate(data) {
    if (data.status === "generated") {
      this.showSuccess(data.url)
      this.unsubscribe()
    } else if (data.status === "errored") {
      this.showError(data.error)
      this.unsubscribe()
    }
  }

  unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
  }

  showProcessingModal() {
    this.modal = document.createElement("div")
    this.modal.className = "fixed inset-0 flex items-center justify-center z-50"
    this.modal.style.backgroundColor = "rgba(0, 0, 0, 0.5)"
    this.modal.appendChild(this.processingTemplateTarget.content.cloneNode(true))
    document.body.appendChild(this.modal)
  }

  showSuccess(url) {
    if (this.modal) {
      this.modal.innerHTML = ""
      const content = this.successTemplateTarget.content.cloneNode(true)
      const downloadLink = content.querySelector("[data-download-link]")
      downloadLink.href = url
      downloadLink.addEventListener("click", () => {
        setTimeout(() => this.closeModal(), 100)
      })
      this.modal.appendChild(content)
    }
  }

  showError(error) {
    if (this.modal) {
      this.modal.innerHTML = ""
      const content = this.errorTemplateTarget.content.cloneNode(true)
      if (error) {
        const errorMessage = content.querySelector("[data-error-message]")
        errorMessage.textContent = error
      }
      this.modal.appendChild(content)
    }
  }

  closeModal() {
    if (this.modal) {
      this.modal.remove()
      this.modal = null
    }
  }

  disconnect() {
    this.unsubscribe()
    this.closeModal()
  }
}
